module.exports = __webpack_public_path__ + "static/media/3.80a61404.png";